import { Icon } from '@iconify/react'
import { FC } from 'react'

import s from './GoogleConnectionFeatures.module.css'

export const GoogleConnectionFeatures: FC = () => {
  return (
    <div className={s.features}>
      Unlock all features by connecting Google:
      <div className={s.feature}>
        <Icon className={s.check} icon="lucide:check-circle" />
        Idea Lab
      </div>
      <div className={s.feature}>
        <Icon icon="uil:lock-alt" className={s.icon} />
        Website Content Audit
      </div>
      <div className={s.feature}>
        <Icon icon="uil:lock-alt" className={s.icon} />
        Analytics & ROI
      </div>
    </div>
  )
}
